import React from "react";
import { Carousel, Tagline, Event } from "../components";

export default function Home() {
    return (
        <div>
            <Carousel />
            <Tagline />
            <Event />
        </div>
    );
}
